export const latinFont = 'https://static.parastorage.com/services/santa/1.1626.17/static/css/user-site-fonts/latin.css';

const fontUrls = [
  'https://static.parastorage.com/services/third-party/fonts/Helvetica/fontFace.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/latin-ext.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/cyrillic.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/korean.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/arabic.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/hebrew.css',
  'https://static.parastorage.com/services/santa-resources/resources/viewer/user-site-fonts/v3/latin.css',
  latinFont
];

export function injectFonts(config) {
  if (typeof window !== 'undefined' && window.document) {
    if (window.document.fonts && window.document.fonts.check) {
      if (config.language === 'vi' && !window.document.fonts.check('12px Open Sans')) {
        injectFont(latinFont);
        return;
      }
      if (window.document.fonts.check('12px helveticaneuew01-65medi')) {
        return;
      }
    }
    fontUrls.forEach(injectFont);
  }
}

function injectFont(url) {
  const link = window.document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', url);

  window.document.body.appendChild(link);
}
